import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom"; //React routes
import { Typography, Box, styled, useTheme } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";

import {
  notificationActions,
  fileActions,
  addTitleLegoCurrent,
} from "../../store/actions"; //Acciones para redux
import {
  InputField,
  CustomLoadingOverlay,
  GenericContainer,
  Buttons,
  UseImage,
} from "../../components";
import { useStyles } from "./OTPFormStyles";
import { coreFunctions, ClearSession } from "../../utils";
import { Alert } from "../../components/Alert";
import otp_phoneImg from "../../assets/otp_phone.svg";
import { Trans, useTranslation } from "react-i18next";

const ContainerImagePIN = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  alignContent: "center",
  alignItems: "center",
  overflow: "hidden",
  textAlign: "center",
  justifyContent: "center",
  [theme.breakpoints.only("xs")]: {
    height: "35vh",
  },
  [theme.breakpoints.only("sm")]: {
    height: "48vh",
  },
  [theme.breakpoints.only("md")]: {
    height: "45vh",
  },
  [theme.breakpoints.only("lg")]: {
    height: "50vh",
  },
  [theme.breakpoints.only("xl")]: {
    height: "55vh",
  },
}));

export default function OTPFormComponent(props) {
  const formMethods = useForm({ mode: "onChange" });
  const { control, handleSubmit, register, formState } = useForm({
    mode: "onBlur",
  });
  const [loadView, setLoadView] = useState(false);
  const theme = useTheme();
  const location = useLocation();
  const localStyles = useStyles();
  const navigate = useNavigate(); //Módulo "History" de react router

  const [logoutOnSave, setLogoutOnSave] = useState("");
  const [fileId, setFileId] = useState(0);
  const [initialState, setInitialState] = useState(false);
  const [notificationActive, setNotificationActive] = useState(false);
  const [otpActive, setOtpActive] = useState(false);

  //Estados de componente
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [sendCodeRetries, setRetries] = useState(1);
  const [stageDescription, setDescription] = useState("Código de seguridad");
  const [activateResend, setActivateResend] = useState(false);
  const [code, setCode] = useState(""); //State CODE
  /*Comienzan métodos y escuchas de componente**/
  const [timerSeconds, setTimerSeconds] = useState(60);

  //Redux hooks
  const auth = useSelector((state) => state.Authentication);
  const file = useSelector((state) => state.FileInfo);
  const notification = useSelector((state) => state.ReSendNip);
  const otpSended = useSelector((state) => state.SendNip);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    if (timerSeconds == 0) {
      //Activa la variable para el boton
      setActivateResend(true);
    }
    // salir cuando lleguemos a 0
    if (!timerSeconds) return;

    // save intervalId para borrar el intervalo cuando el componente vuelve a renderizar
    const intervalId = setInterval(() => {
      setTimerSeconds(timerSeconds - 1);
    }, 1000);

    // clear interval al volver a renderizar para evitar pérdidas de memoria
    return () => clearInterval(intervalId);
  }, [timerSeconds]);

  //Promesa general Init
  useEffect(() => {
    dispatch(addTitleLegoCurrent(""));
    // console.log("location.state: ", location.state)
    // console.log("location.state.folioId: ", location.state.folioId)
    console.log("OTPEnvio 0", location.state.folioId);

    // dispatch(notificationActions.ReSendNip(location.state.folioId))

    setInitialState(false);
    if (!initialState) {
      setFileId(location.state.folioId);
      dispatch(
        addTitleLegoCurrent(
          location.state.stage.Stage === undefined
            ? location.state.stage.Description
            : location.state.stage.Stage.Description
        )
      );
      dispatch(fileActions.GetFileInfo(location.state.folioId));
      // console.log("location.state: ", location.state)
    }
  }, []);

  useEffect(() => {
    // console.log(".........initialState....fileId..: ", initialState, fileId)
    if (!initialState && fileId != undefined && fileId != null) {
      console.log("OTPEnvio 1", fileId);
      dispatch(notificationActions.ReSendNip(fileId || location.state.folioId));
      setInitialState(true);
    }
  }, [fileId]);

  useEffect(() => {
    setLoadView(notification.loading);
    if (notification.items != undefined && notificationActive) {
      setNotificationActive(false);
      setActivateResend(false);
    } else if (notification.error != undefined && notificationActive) {
      setNotificationActive(false);
      setActivateResend(true);
      setLoadView(false);

      Alert(
        {
          icon: "error",
          okbtntext: t("general_accept"),
          text: notification.error,
        },
        (event) => {}
      );
    }
  }, [notification]);

  useEffect(() => {
    setLoadView(otpSended.loading);
    if (otpSended.items != undefined && otpActive) {
      console.log("otpSended.items: ", otpSended.items);
      let nextStage = otpSended.items.Stage;
      let stageName = nextStage.Name;
      let stageId = nextStage.Id;
      let folioId = fileId;
      let stage = otpSended.items;
      
      if (logoutOnSave && logoutOnSave == "1") {
        //Logout y redireccion a login
        console.log("LogoutOnSave::clearsesion");
        Alert(
          {
            icon: "success",
            text: t("proccess_request"),
            okbtntext: t("general_accept"),
          },
          () => {
            ClearSession();
            navigate("/auth/");
          }
        );
      }

      let nextComponent = coreFunctions.GetLegoNext(stageName);
      coreFunctions.DoNextStage({
        navigate,
        nextComponent,
        State: { stageName, stageId, stage, folioId },
      });
    } else if (otpSended.error != undefined && otpActive) {
      setOtpActive(false);
      setLoadView(false);
      Alert(
        {
          icon: "error",
          okbtntext: t("general_accept"),
          text: otpSended.error,
        },
        (event) => {}
      );
    }
  }, [otpSended]);

  useEffect(() => {
    if (file.items != undefined) {
      let phone = file.items.PhoneNumber != null && file.items.PhoneNumber;
      let email = file.items.Email != null && file.items.Email;
      // Muestra "Moz"
      if (file.items.PhoneNumber != null && file.items.Email != null) {
        let firstPart = phone.substring(2, 10);
        let phoneNumber2 = phone.replace(firstPart, "-XXXX-XX-");
        let firstPartE = email.substring(1, email.indexOf("@") - 1);
        let emailStr = email.replace(firstPartE, "xxxxx");
        setPhoneNumber(phoneNumber2);
        setEmail(emailStr);
      }

      setFullName(file.items.FullName);
      setFileId(file.items.Id);
      dispatch(addTitleLegoCurrent(file.items.Stage.Description));
      console.log("OTPEnvio 2", file.items.Id);
      let LogoutOnSave = file.items?.Stage?.Properties?.find(
        ({ Name }) => Name === "LogoutOnSave"
      )?.Value;
      setLogoutOnSave(LogoutOnSave);
      // dispatch(notificationActions.ReSendNip(file.items.Id))
      // setDescription(file.items.Stage.Description)
    }
  }, [file]);

  let handleSend = (data) => {
    // console.log("data: ------: ", data)
    dispatch(
      notificationActions.SendNip({
        File_id: fileId,
        PIN: data["txtPIN"],
      })
    );
    setOtpActive(true);
  };

  //Método controlador de reenvió de pin o edición de datos
  let handleRetry = () => {
    setTimerSeconds(60);
    if (activateResend) {
      setRetries(sendCodeRetries + 1);
      if (sendCodeRetries >= 2) {
        setRetries(1);
        console.log("......location.state......: ", location.state);
        navigate(`/main/OTPEditData`, {
          state: {
            stageName:
              location.state.stage.Stage === undefined
                ? location.state.Name
                : location.state.stage.Stage.Name,
            stageId:
              location.state.stage.Stage === undefined
                ? location.state.stage.Id
                : location.state.stage.Stage.Id,
            stage:
              location.state.stage.Stage === undefined
                ? location.state.stage
                : location.state.stage.Stage,
            folioId: fileId,
          },
        });
      } else {
        console.log("OTPEnvio 3");
        dispatch(notificationActions.ReSendNip(fileId));
        setNotificationActive(true);
      }
    }
  };

  //Comienza interfaz
  return (
    <GenericContainer>
      <FormProvider {...formMethods}>
        {/* <Typography variant="h6">
        {stageDescription}
      </Typography> */}
        <ContainerImagePIN>
          <UseImage className={localStyles.imgPin} src={otp_phoneImg} />
        </ContainerImagePIN>
        <Box sx={{ textAlign: "justify" }}>
          <Typography variant="subtitle1">
            <Trans
              i18nKey="applicant_security_code"
              values={{ phoneNumber, email }}
              components={{ bold: <b /> }}
            />
          </Typography>
          <Typography variant="subtitle1" sx={{ marginTop: "5px !important" }}>
            <Trans
              i18nKey="applicant_security_not_found"
              components={{ bold: <b /> }}
            />
          </Typography>
        </Box>
        <InputField
          inputType="PIN"
          control={control}
          register={register}
          name="txtPIN"
          label={t("applicant_code")}
          validations={{ required: true }}
          required={true}
          error={!!formState.errors["txtPIN"]}
          helperText={formState.errors["txtPIN"]?.message}
        />
        <Typography variant="caption">
          {t("applicant_new_code", { timerSeconds })}
        </Typography>
        <Buttons //disabledConfirm={activePINButton ? false : true}
          ConfirmButtonText={t("applicant_code_verification")}
          onClickConfirm={handleSubmit(handleSend)}
          disabledCancel={!activateResend}
          CancelButtonText={t("applicant_resend_code")}
          onClickCancel={handleRetry}
        />
        {loadView ? (
          <CustomLoadingOverlay
            active={loadView}
            text={t("general_loading_message")}
          />
        ) : null}
      </FormProvider>
    </GenericContainer>
  );
}
